const TICKET_QUANTITY_PATTERN = /^(\d+|\d{1,3}(,\d{3})+)(\.\d+)?$/;

export const parseTicketQuantity = (value?: string | null) => {
  const trimmed = value?.trim();

  if (!trimmed || !TICKET_QUANTITY_PATTERN.test(trimmed)) {
    return null;
  }

  // Digit strings past the numeric range become Infinity, which JSON serializes as null.
  const quantity = Number(trimmed.replaceAll(',', ''));

  return Number.isFinite(quantity) ? quantity : null;
};

export const toNullableId = (value?: string) =>
  value === undefined ? undefined : value || null;
